(function () {
    'use strict';

    angular
        .module('jotApp')
        .factory('Team', Team);

    Team.$inject = ['$resource'];

    function Team($resource) {
        var service = $resource('api/team/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'usersDomain': {
                url:'api/team/usersByDomain/:id',
                method: 'GET',
                isArray: true
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });

        return service;
    }
})();
